import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import "../../../../assets/styles/audio-question.css";
import { makeArrayRandom } from "../../../../utils/learner";

export default function WebCorrectOrderMatchEmail({ question, onAnswer = () => {} }) {
    const questionData = question;
    const { questionHtml, questionList, answer } = questionData;

    const headerItems = questionHtml.split("<br />").map((item) => {
        const keyValue = item.replace(/<\/?b>/g, "").split("</span>");
        return keyValue.map((value) => value.trim());
    });
    
    const emptyBoxesCount = answer.value.length;

    const [selectedKeyPrevious, setSelectedKeyPrevious] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [leftItems, setLeftItems] = useState(
        makeArrayRandom(questionList.map((item) => item.id))
    );
    const [rightColumn, setRightColumn] = useState(
        Array(emptyBoxesCount).fill(null)
    );

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setSelectedKeyPrevious(null);
        setSelectedItem(null);
        setLeftItems(makeArrayRandom(questionList.map((item) => item.id)));
        setRightColumn(Array(emptyBoxesCount).fill(null));
    }, [question,
        questionList,
        emptyBoxesCount,
    ]);

    const handleSelectItem = (item) => {
        setSelectedItem(item);
        setSelectedKeyPrevious(null);
    };

    const handleTransferItem = (index) => {
        if (selectedItem !== null) {
            const updatedRightColumn = [...rightColumn];
            const updatedLeftItems = leftItems.filter(
                (item) => item !== selectedItem
            );

            if (!updatedRightColumn[index]) {
                if (selectedKeyPrevious !== null) {
                    updatedRightColumn[selectedKeyPrevious] = null;
                    setSelectedKeyPrevious(null);
                }
                updatedRightColumn[index] = selectedItem;

                setRightColumn(updatedRightColumn);
                setLeftItems(updatedLeftItems);
                setSelectedItem(null);

                const canProceed = true;
                onAnswer({
                    canProceed,
                    answer: updatedRightColumn,
                });
            }
        }
    };

    const handleRemoveFromRight = (index) => {
        const updatedRightColumn = [...rightColumn];
        const itemToRemove = updatedRightColumn[index];
        if (itemToRemove) {
            updatedRightColumn[index] = null;
            setRightColumn(updatedRightColumn);
            setLeftItems([...leftItems, itemToRemove]);

            let canProceed = false;
            updatedRightColumn.map((value, index) => {
                if (value !== null && value !== "") {
                    canProceed = true;
                }
                return value;
            });

            onAnswer({
                canProceed,
                answer: updatedRightColumn,
            });
        }
    };

    const handleAnswerClick = (content, index) => {
        if (selectedItem && content !== "") {
            const updatedRightColumn = [...rightColumn];
            let updatedLeftItems = [...leftItems];
            if (selectedKeyPrevious !== index) {
                updatedRightColumn[index] = selectedItem;
                setRightColumn(updatedRightColumn); // add to right column

                // remove the currect selected left items and add again the right colum
                updatedLeftItems = updatedLeftItems.filter(
                    (item) => item !== selectedItem
                );
                updatedLeftItems = [...updatedLeftItems, content];
                setLeftItems(updatedLeftItems);

                setSelectedKeyPrevious(null);
                setSelectedItem(null);
            }
        } else {
            const item = questionList.map((item) => item.id).find((c) => c === content);
            setSelectedItem(item);
            setSelectedKeyPrevious(index);
        }
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#7A8C8E",
                padding: "20px",
                borderRadius: "10px",
                borderBottom: "10px solid #5B696B",
                width: "100%",
                maxWidth: "900px",
                margin: "auto",
            }}
        >
            <Box sx={{ marginBottom: "20px", color: "black" }}>
                {headerItems.map((item, index) => (
                    <Typography
                        key={index}
                        variant="body1"
                        sx={{ fontWeight: "bold", marginBottom: "5px" }}
                    >
                        <span
                            dangerouslySetInnerHTML={{ __html: item[0] + ":" }}
                        />
                        <span dangerouslySetInnerHTML={{ __html: item[1] }} />
                    </Typography>
                ))}
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={6}>
                    {leftItems.map((item, index) => (
                        <Box
                            key={index}
                            onClick={() => handleSelectItem(item)}
                            sx={{
                                backgroundColor:
                                    selectedItem === item
                                        ? "rgb(170, 214, 231)"
                                        : "rgb(170, 214, 231)",
                                borderBottom: "4px solid rgb(52, 148, 186)",
                                padding: "10px",
                                borderRadius: "5px",
                                width: "100%",
                                height: "54px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "bold",
                                fontSize: "18px",
                                marginBottom: "10px",
                                cursor: "pointer",
                                boxShadow:
                                    selectedItem === item
                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                        : "none",
                            }}
                        >
                            {item}
                        </Box>
                    ))}
                </Grid>

                <Grid item xs={6}>
                    {rightColumn.map((content, index) => (
                        <Box
                            key={index}
                            onClick={() =>
                                !content && handleTransferItem(index)
                            }
                            sx={{
                                position: "relative",
                                backgroundColor: content
                                    ? "rgb(170, 214, 231)"
                                    : "#ffffff",
                                border: "2px dashed #A3BBC0",
                                padding: "10px",
                                borderRadius: "5px",
                                width: "100%",
                                height: "54px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: "10px",
                                cursor: content ? "pointer" : "pointer",
                                fontWeight: "bold",
                                fontSize: "18px",
                                boxShadow:
                                    selectedItem != null
                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                        : "none",
                            }}
                        >
                            {content && (
                                <Typography
                                    sx={{
                                        fontWeight: "bold",
                                        textAlign: "center",
                                        fontSize: "18px",
                                        width: "100%",
                                    }}
                                    onClick={() => handleAnswerClick(content, index)}
                                >
                                    {content}
                                </Typography>
                            )}
                            {content && (
                                <Box
                                    className="selected-close-btn"
                                    sx={{
                                        top: "0px",
                                        right: "0px",
                                        fontWeight: "bold",
                                        width: "17.33px",
                                        height: "20px",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemoveFromRight(index);
                                    }}
                                >
                                    X
                                </Box>
                            )}
                        </Box>
                    ))}
                </Grid>
            </Grid>
        </Box>
    );
};
